import React from 'react'
import "./stylesheet/body.css"
import { Header, Intro } from './subComponent'
import { Icon } from '@iconify/react';
import { NavLink } from 'react-router-dom';


export const Footer=()=>{
  return(
    <div className="icon">

  <NavLink className="cir" to="/" >    <Icon icon="clarity:home-line"  color='black' width={"20px"} /> </NavLink>
  <NavLink className="cir" to="/about" >     <Icon icon="cib:about-me" color='black' width={"20px"} /> </NavLink>
   {/* <NavLink className="cir" to="/portfolio" >    <Icon icon="dashicons:portfolio" color='black'/> </NavLink> */}
    </div>
  )
}
const Body = () => {
  return (
<>
<section className="containerm">
  <div className="upperm">
  <Header/>
<Intro/>
  </div>
  <div className="footer">
    <Footer></Footer>
    
    </div>

</section>
</>
  )
}

export default Body